import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';
import { Observable, of } from 'rxjs';

const residueURL = `${environment.api}/residuespbi/`;
const sprintURL = `${environment.api}/sprints/`;
const capacityURL = `${environment.api}/capacities/`;
const storyPointsURL = `${environment.api}/storypoints/`;
const csvInsertURL = `${environment.api}/azuredata/`;

@Injectable({
  providedIn: 'root'
})
export class ScrumService {
  constructor(private http: HttpClient) {}

  residuepbi(sprint_id: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    return of({ result: [] });
  }

  saveResiduePbi(body?: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    return this.http.post<any>(residueURL + 'massiveStoreUpdate', body, {
      context: new HttpContext().set(CONFIG, config)
    });
  }

  deleteResidue(residue_id: any, sprint_id: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      sprint_id
    };
    return this.http.delete<any>(residueURL + `${residue_id}/destroy`, {
      headers,
      body
    });
  }

  createSprint(sprint: any) {
    return this.http.post<any>(sprintURL + 'store', sprint);
  }

  updateSprint(sprint_data: any, sprint_id: any) {
    return this.http.post<any>(sprintURL + `${sprint_id}/update`, sprint_data);
  }

  indexCapacitySprint(
    project_id: number,
    sprint_id: any,
    calendar_start_date: any = null,
    calendar_end_date: any = null
  ) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);
    return this.http.get<any>(sprintURL + `${project_id}/index`, {
      context,
      params: new HttpParams()
        .set('sprint_id', sprint_id)
        .set('start_date', calendar_start_date)
        .set('end_date', calendar_end_date)
    });
  }

  updateCapacitySprint(params: {}, capacity_id: number) {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    return this.http.patch<any>(
      capacityURL + `${capacity_id}/updateCapacity`,
      params,
      { context: new HttpContext().set(CONFIG, config) }
    );
  }

  updateCapacitySprintStatistic(
    capacity_id: number,
    value: number,
    sprint_id: any,
    billing_value?: number
  ) {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    let params: any = {
      value: value,
      sprint_id: sprint_id,
      billing_value: billing_value
    };

    return this.http.put<any>(sprintURL + `${capacity_id}/updateSP`, params, {
      context: new HttpContext().set(CONFIG, config)
    });
  }

  getDataSprint(id: number, startSprintNumber?: any, endSprintNumber?: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);
    let params: any;
    if (
      startSprintNumber != undefined &&
      startSprintNumber != null &&
      endSprintNumber != undefined &&
      endSprintNumber != null
    ) {
      params = {
        start_sprint_number: startSprintNumber,
        end_sprint_number: endSprintNumber
      };
    }
    return this.http.get<any>(sprintURL + `${id}/getDataSprint`, {
      context,
      params
    });
  }

  updateTeamCategory(sprint_id: number, teamcategory_id: number) {
    // Route::patch('{id}/teamcategory/{teamcategory_id}/updateTeamCategory', 'updateTeamCategory');
    return this.http.patch<any>(
      sprintURL +
        `${sprint_id}/teamcategory/${teamcategory_id}/updateTeamCategory`,
      null
    );
  }

  toggleConcludeSprint(sprint_id: number) {
    return this.http.patch<any>(
      sprintURL + `${sprint_id}/toggleConcludeSprint`,
      null
    );
  }

  indexStoryPoints(
    requestData?: any,
    excludeLoader: boolean = true
  ): Observable<any> {
    return of({ result: [] });
  }

  getAllStoryPoints(): Observable<any> {
    return of({ result: [] });
  }

  getAllStorypointCategories(): Observable<any> {
    return of({ result: [] });
  }

  selectPeople(project_id: number, start_date: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);
    return this.http.get<any>(capacityURL + `${project_id}/selectPeople`, {
      context,
      params: new HttpParams().set('start_sprint', start_date)
    });
  }

  insertData(formData: FormData): Observable<any> {
    const headers = new HttpHeaders(); // Non aggiungere alcuna intestazione (FormData gestirà il tipo di contenuto)

    return this.http.post<any>(csvInsertURL + 'insertData', formData, {
      headers
    });
  }

  getResiduesPbi(sprintId: number): Observable<any> {
    return of({ result: [] });
  }

  getCurrentResiduesPbi(sprintId: number): Observable<any> {
    return of({ result: [] });
  }

  calculateComplexity(data: any): Observable<any> {
    return of({ result: null });
  }

  /**
   * Aggancio BE per gestire la checkbox di completamento del `Daily` sull'header della tabella scrum
   *
   * @param sprintId sprint id
   * @param date data della checkbox
   * @param typology `Daily` o `Planning` o `Sprint Review`
   */
  toggleDaily = (
    sprintId: number,
    date: string,
    typology: string,
    billing_value?: number
  ): Observable<any> => {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);

    return this.http.patch(
      capacityURL + `toggleDailyDone`,
      {
        sprint_id: sprintId,
        date: date,
        typology: typology,
        billing_value: billing_value
      },
      { context }
    );
  };

  updateUserCapacity = (
    sprintId: number,
    date: string,
    typology: string,
    billing_value?: number,
    value?: any
  ): Observable<any> => {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);

    return this.http.post<any>(capacityURL + `updateUserCapacity`, {
      sprint_id: sprintId,
      date: date,
      typology: typology,
      billing_value: billing_value,
      value: value
    });
  };

  /**
   * Aggancio per prendermi i progetti che non hanno CSV
   */
  getProjectSprintWithCsv(project_id: number): Observable<any> {
    return this.http.get<any>(
      `${sprintURL}getProjectSprintWithCsv/${project_id}`
    );
  }
}
